// Define a type for different environments
type Environment = 'local+api' | 'local' | 'development' | 'test' | 'production';

// Set the environment based on the NODE_ENV environment variable
export const environment = process.env.NODE_ENV as Environment;

// Function to get the base URL based on the environment
export function GetBaseUrl(): string {
  switch (environment) {
    // Local environment with a separate API server
    case 'local+api':
      return 'https://localhost:7289';

    // Test environment
    case 'test':
      return 'https://cloudtest.usf.edu/ons/api';

    // Production environment
    case 'production':
      return 'https://cloud.usf.edu/ons/api';

    // Default to local or development environment
    default:
    case 'local':
    case 'development':
      return 'https://clouddev.usf.edu/ons/api';
  }
}
